const DOCUMENT = 'GLOBAL_SEARCH_';

const actions = {
  SEARCH_REQUEST: DOCUMENT + 'SEARCH_REQUEST',
  SEARCH_SUCCESS: DOCUMENT + 'SEARCH_SUCCESS',
  SEARCH_ERROR: DOCUMENT + 'SEARCH_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  GET_RECENT_REQUEST: DOCUMENT + 'GET_RECENT_REQUEST',
  GET_RECENT_SUCCESS: DOCUMENT + 'GET_RECENT_SUCCESS',
  GET_RECENT_ERROR: DOCUMENT + 'GET_RECENT_ERROR',
  CLICK_ITEM_REQUEST: DOCUMENT + 'CLICK_ITEM_REQUEST',
  CLICK_ITEM_SUCCESS: DOCUMENT + 'CLICK_ITEM_SUCCESS',
  CLICK_ITEM_ERROR: DOCUMENT + 'CLICK_ITEM_ERROR',

  clickItemRequest: data => ({
    type: actions.CLICK_ITEM_REQUEST,
    payload: data,
  }),

  clickItemSuccess: data => ({
    type: actions.CLICK_ITEM_SUCCESS,
    payload: data,
  }),

  clickItemError: () => ({
    type: actions.CLICK_ITEM_ERROR,
  }),

  getRecentRequest: () => ({
    type: actions.GET_RECENT_REQUEST,
  }),

  getRecentSuccess: data => ({
    type: actions.GET_RECENT_SUCCESS,
    payload: data,
  }),

  getRecentError: () => ({
    type: actions.GET_RECENT_ERROR,
  }),

  searchRequest: data => ({
    type: actions.SEARCH_REQUEST,
    payload: data,
  }),

  searchSuccess: data => ({
    type: actions.SEARCH_SUCCESS,
    payload: data,
  }),

  searchError: () => ({
    type: actions.SEARCH_ERROR,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
